// Adaptive quality decisions. The frame rate is measured in 2 s windows; these functions say what a window means.

// 0 high … 3 minimum: render resolution, shadow refresh rate, post-processing and crowd distance.
export const TIERS = [
  { pr: 1.5, shadowEvery: 2, bloom: true, tilt: true, cull: 48 },
  { pr: 1.25, shadowEvery: 2, bloom: true, tilt: true, cull: 42 },
  { pr: 1, shadowEvery: 3, bloom: false, tilt: false, cull: 34 },
  { pr: 0.8, shadowEvery: 5, bloom: false, tilt: false, cull: 28 },
];
export const MAX_TIER = TIERS.length - 1;

// Mean and standard deviation of the frame gaps (ms) in a window.
export function gapStats(gaps) {
  const mean = gaps.reduce((a, b) => a + b, 0) / gaps.length;
  const sd = Math.sqrt(gaps.reduce((a, b) => a + (b - mean) * (b - mean), 0) / gaps.length);
  return { mean, sd };
}

// A steady ~30 fps with very even frame times is a browser/OS cap, not a GPU that cannot keep up.
export const isFrameCap = (fps, sd) => fps > 27 && fps < 32 && sd < 3;

// Counts consecutive slow or fast windows on `perf` and returns the tier change to make: 1 (step down), -1 (step up)
// or 0. Below ~42 fps twice in a row it steps down; above ~57 fps for four windows it steps back towards where it began.
export function tierStep(perf, fps) {
  if (fps < 42) {
    perf.fast = 0;
    if (++perf.slow >= 2 && perf.tier < MAX_TIER) return 1;
  } else if (fps > 57) {
    perf.slow = 0;
    if (++perf.fast >= 4 && perf.tier > perf.startTier) return -1;
  } else perf.slow = perf.fast = 0;
  return 0;
}

// True once the lowest tier still cannot keep 30 fps for three windows: no setting of ours helps any more.
export function stuckAtMinimum(perf, fps) {
  if (perf.tier === MAX_TIER && fps < 30) return ++perf.verySlow >= 3;
  perf.verySlow = 0;
  return false;
}
